import { CUSTOM_SERVICES } from './../../../config/cmp';
import { getCurrentFrontendConfig } from '~/jobiqo/context/frontendConfig';

export interface Consent {
  // The internal identifier.
  serviceID;
  // The consent status.
  status: boolean;
}

export const allowedCmpProviders = {
  Usercentrics: 'Usercentrics',
  OneTrust: 'OneTrust',
  ConsentManager: 'ConsentManager',
  TrustCommander: 'TrustCommander',
  Traffective: 'Traffective',
  Didomi: 'Didomi',
  CivicCookieControl: 'CivicCookieControl',
  CookieScript: 'CookieScript',
};

export const getCmpProvider = () =>
  getCurrentFrontendConfig().APP.CMP_PROVIDER ||
  allowedCmpProviders.Usercentrics;

export const DEFAULT_SERVICES = {
  Usercentrics: {
    GoogleTagmanager: 'Google Tag Manager',
    GoogleAnalytics4: 'Google Analytics 4',
    GoogleGeosuggest: 'Google Maps Geocoding',
    GoogleAnalytics: 'Google Analytics',
    GoogleAdmanager: 'Google Ad Manager',
    Youtube: 'YouTube Video',
    Vimeo: 'Vimeo',
    Snowplow: 'Snowplow',
    MetaPixel: 'Meta Pixel',
    Oewa: 'Oewa',
    Mapbox: 'Mapbox',
    Hotjar: 'Hotjar',
  },
  OneTrust: {
    GoogleTagmanager: 'C0001',
    GoogleAnalytics4: 'C0002',
    GoogleGeosuggest: 'C0003',
    GoogleAnalytics: 'C0002',
    GoogleAdmanager: 'C0004',
    Youtube: 'C0003',
    Vimeo: 'C0003',
    // Snowplow: 'C0002',
    Oewa: 'C0002',
    // Mapbox: 'C0003',
    // Hotjar: 'C0003',
  },
  ConsentManager: {
    GoogleTagmanager: 's905',
    GoogleAnalytics4: 's26',
    GoogleGeosuggest: 's135',
    GoogleAnalytics: 's26',
    GoogleAdmanager: 's1',
    Youtube: 's30',
    Vimeo: 's77',
    // Snowplow: 'Snowplow',
    // Oewa: 'Oewa',
    // Mapbox: 'Mapbox',
    Hotjar: 's46',
  },
  TrustCommander: {
    // @todo: add correct mapping.
    GoogleTagmanager: '2',
    GoogleAnalytics4: '1',
    // GoogleGeosuggest: 'C0003',
    GoogleAnalytics: '1',
    GoogleAdmanager: '2',
    // Youtube: 'C0003',
    // Vimeo: 'C0003',
    Oewa: '1',
    // Mapbox: 'C0003',
    // Hotjar: '3',
  },
  Traffective: {
    GoogleTagmanager: 'Google Tag Manager',
    GoogleAnalytics4: 'Google Analytics 4',
    GoogleGeosuggest: 'Google Maps Geocoding',
    GoogleAnalytics: 'Google Analytics',
    GoogleAdmanager: 'Google Ad Manager',
    Youtube: 'YouTube Video',
    Vimeo: 'Vimeo',
    Snowplow: 'Snowplow',
    Oewa: 'Oewa',
    Mapbox: 'Mapbox',
    Hotjar: 'Hotjar',
  },
  Didomi: {
    GoogleTagmanager: 'GoogleTagmanager',
    GoogleAnalytics4: 'googleana-4TXnJigR',
    // GoogleGeosuggest: 'GoogleGeosuggest',
    GoogleAnalytics: 'googleana-4TXnJigR',
    GoogleAdmanager: 'google',
    Youtube: 'youtubeem-6CqhAjLn',
    Vimeo: 'vimeoembe-6acYqiaL',
    // Snowplow: 'Snowplow',
    MetaPixel: 'facebookp-xqnpqZGA',
    // Oewa: 'Oewa',
    // Mapbox: 'Mapbox',
    Hotjar: 'hotjar',
  },
  CivicCookieControl: {
    GoogleTagmanager: 'necessary',
    GoogleAnalytics4: 'analytics',
    GoogleGeosuggest: 'functional',
    GoogleAnalytics: 'analytics',
    GoogleAdmanager: 'marketing',
    Youtube: 'functional',
    Vimeo: 'functional',
    Snowplow: 'analytics',
    Oewa: 'analytics',
    Mapbox: 'functional',
    Hotjar: 'functional',
  },
  CookieScript: {
    GoogleTagmanager: 'strict',
    GoogleAnalytics4: 'performance',
    GoogleGeosuggest: 'functionality',
    GoogleAnalytics: 'performance',
    GoogleAdmanager: 'targeting',
    Youtube: 'targeting',
    Vimeo: 'functionality',
    Snowplow: 'performance',
    Oewa: 'performance',
    Mapbox: 'functionality',
    Hotjar: 'functionality',
  },
};

const getServicesMap = () => ({
  ...(DEFAULT_SERVICES[getCmpProvider()] ?? {}),
  ...CUSTOM_SERVICES,
});

export const SERVICES: Record<string, string> = new Proxy(
  {},
  {
    get(_target, prop: string) {
      return getServicesMap()?.[prop];
    },
    ownKeys() {
      return Reflect.ownKeys(getServicesMap());
    },
    getOwnPropertyDescriptor() {
      return {
        enumerable: true,
        configurable: true,
      };
    },
  },
) as Record<string, string>;
